import { cva } from "class-variance-authority";

export const contextMenuItemVariants = cva(
  "group/context-menu-item flex w-full cursor-pointer items-center rounded-md px-2 py-1.5 transition-colors duration-200",
  {
    variants: {
      variant: {
        primary: "text-gray-700 hover:bg-gray-50 hover:text-gray-900",
        destructive: "text-red-600 hover:!bg-red-50 hover:!text-red-700",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export const contextMenuIconVariants = cva(
  "mr-2 inline-flex h-5 w-5 shrink-0 items-center justify-center transition-colors duration-200",
  {
    variants: {
      variant: {
        primary: "text-gray-400 group-hover/context-menu-item:text-gray-600",
        destructive: "text-red-400 group-hover/context-menu-item:text-red-600",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);
